// -- Analytics stuff --

import { httpsCallable } from "firebase/functions";
import { functions } from "../../config/firebase-config";

export const safeTrackPostAnalytics = async ({actionType, postId, analyticsMetaData}) => {
    // Logic for not calling more than once per session

    const {
        trackedViews,
        trackedDms,
        trackedCopiedLinks,
        trackedLinkClicks,
        userId
    } = analyticsMetaData;
    
    if(actionType === 'view') {
        if (trackedViews.current.has(postId)) return;
        trackedViews.current.add(postId);
    } else if(actionType === 'direct_message') {
        if (trackedDms.current.has(postId)) return;
        trackedDms.current.add(postId);
    } else if(actionType === 'copied_link') {
        if (trackedCopiedLinks.current.has(postId)) return;
        trackedCopiedLinks.current.add(postId);
    } else if(actionType === 'external_link_click') {
        if (trackedLinkClicks.current.has(postId)) return;
        trackedLinkClicks.current.add(postId);
    } else {
        console.log('No valid actionType for analytics');
        return;
    }
    
    await trackPostAnalytics({actionType, postId, userId});
};

const trackPostAnalytics = async ({actionType, postId, userId}) => {
    const trackAnalytics = httpsCallable(functions, "trackPostAnalytics");
    try {
        const ipAddress = await getVisitorIP();
        if(ipAddress?.length > 0 && postId && actionType) {
            await trackAnalytics({ actionType: actionType, postId: postId, ipAddress: ipAddress, userId: userId });
        }
    } catch (err) {
        console.error("Error 473:", err);
    }
}

const getVisitorIP = async () => {
    try {
        const response = await fetch('https://api.ipify.org');
        const data = await response.text();

        // Store IP in State
        return data;
    } catch (error) {
        console.error('CODE 511', error)
        return null;
    }
}

// -- END: Analytics stuff --

export default safeTrackPostAnalytics;